import React, { useEffect, useMemo, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useAxios } from "../../utils/useAxios";
import MapSidebar from "../../components/Dashboard/Map/SideMenu";
import TrackingMap from "../../components/Dashboard/Map/TrackingMap";

// Sample truck location data

const containerStyle = {
  width: "100%",
  height: "600px",
};

const center = { lat: 39.8282, lng: -98.5796 }; // Center of India

type MarkerData = {
  position: { lat: number; lng: number };
  count: number;
};

export default function ShipperTrailer() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
      "AIzaSyDcsk4INHelSsIS5irDYRQFN-DMJdyJNzA", // 🔐 replace with yours
  });

  const [selectedMarker, setSelectedMarker] = useState<MarkerData | null>(null);

  const [list, setList] = useState([]);
  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/inventoryHistory",
    onSuccess: (data) => {
      setList(data?.data);
      console.log(data?.data);
    },
  });
  useEffect(() => {
    mutate({
      getTrailerlist: true,
      table: "InventoryHistory",
    });
  }, []);

  const sortlist = list.sort((a: any, b: any) => b.id - a.id);

  const uniqueByTrailer = sortlist.filter(
    (item: any, index: number, self: any) =>
      index === self.findIndex((t: any) => t.trailer_id === item.trailer_id),
  );

  const shipperDropped = uniqueByTrailer?.filter(
    (items: any) =>
      items?.trailerStatus === "Dropped" && items?.shipper !== null,
  );
  const consigneeDropped = uniqueByTrailer?.filter(
    (items: any) =>
      items?.trailerStatus === "Dropped" && items?.consignee !== null,
  );
  const terminalDropped = uniqueByTrailer?.filter(
    (items: any) =>
      items?.trailerStatus === "Dropped" && items?.terminal !== null,
  );

  //   console.log(shipperDropped);

  // Utility to group and count
  const groupedShippers = shipperDropped.reduce((acc: any, item: any) => {
    const id = item?.shipper?.id;
    if (!id) return acc;

    if (!acc[id]) {
      acc[id] = {
        id,
        name: item.shipper.name,
        address: item.shipper.address,
        lat: item.shipper.lat,
        lng: item.shipper.lng,
        count: 1,
      };
    } else {
      acc[id].count += 1;
    }

    return acc;
  }, {});

  const shipperList = Object.values(groupedShippers);

  console.log(shipperList);

  const trucks = shipperList;

  //   [
  //     { id: 1, lat: 34.0522, lng: -118.2437, location: "Los Angeles, CA" },
  //     { id: 16, lat: 34.0522, lng: -118.2437, location: "Los Angeles, CA" },
  //   ];

  // Group trucks by lat,lng
  const groupedTrucks: Record<string, any[]> = useMemo(() => {
    const groups: Record<string, any[]> = {};
    trucks.forEach((truck: any) => {
      const lat = Number(truck.lat);
      const lng = Number(truck.lng);
      const key = `${lat},${lng}`;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(truck);
    });
    return groups;
  }, [trucks]);

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-3">
        <MapSidebar shippers={shipperList} />
      </div>
      <div className="col-span-9">
        <div style={{ width: "100%", height: "calc(100vh - 80px)" }}>
          <TrackingMap groupedTrucks={groupedTrucks} />
          {/* <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={4}
          >
            {Object.entries(groupedTrucks).map(([key, group]: any) => {
              const [lat, lng] = key.split(",").map(Number);
              const position = { lat, lng };

              return (
                <Marker
                  key={key}
                  position={position}
                  label={{
                    text: group.length.toString(),
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                  //   icon={{
                  //     url: "/images/truck.svg", // relative or absolute URL
                  //     scaledSize: new window.google.maps.Size(40, 40), // scale size
                  //   }}
                  icon={{
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#009900",
                    fillOpacity: 1,
                    strokeWeight: 1,
                    strokeColor: "white",
                  }}
                  onClick={() =>
                    setSelectedMarker({ position, count: group.length })
                  }
                />
              );
            })}

            {selectedMarker && (
              <InfoWindow
                position={selectedMarker.position}
                onCloseClick={() => setSelectedMarker(null)}
              >
                <div>Trucks at this location: {selectedMarker.count}</div>
              </InfoWindow>
            )}
          </GoogleMap> */}
        </div>
      </div>
    </div>
  );
}
